<template>
  <div>
    <credit-table-filter @change="getItemsByFilter"></credit-table-filter>


    <div>
      <v-card-title class="px-0 pb-1 pt-1">Кредиты</v-card-title>
      <v-tabs v-model="statusStep">
        <v-tab href="#tab-all">Все</v-tab>
        <v-tab href="#tab-2">Активные</v-tab>
        <v-tab href="#tab-1">Ждёт подтверждение</v-tab>
        <v-tab href="#tab-3">Ждёт первоначальный взнос</v-tab>
        <v-tab href="#tab-5">Закрытые</v-tab>
        <v-tab href="#tab-0">Отменен</v-tab>
      </v-tabs>

    </div>
    <v-data-table
        :custom-sort="item => item"
        :headers="headers"
        :items="items"
        :options.sync="options"
        disable-pagination
        hide-default-footer>
      <template #top>
        <div class="d-flex pa-3 ma-n2 justify-end flex-wrap">
          <div class="pa-2">
            <v-btn @click="$router.push({name: 'credit-create'})" className="action-btn" color="primary" smal>
              <v-icon class="mr-2">fas fa-plus</v-icon>
              Создать новый
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:body="{items}">
        <tbody>
        <tr :key="item.credit_number" v-for="(item,i) in items">
          <td>{{ getNumber(i) }}</td>
          <td>{{ item.credit_number }}</td>
          <td>{{ item.full_name }}</td>
          <td>{{ item.old_amount|money }}</td>
          <td>{{ item.period }}</td>
          <td>
            <v-chip :color="item.current_debt > 0 ? 'pink' : ''" :text-color="item.current_debt > 0 ? 'white' : ''"
                    class="ma-2" label>
              {{ (Math.ceil(item.current_debt))|money }}
            </v-chip>
          </td>
          <td>{{ item.created_at }}</td>
          <td>{{ item.start_date }} - {{ item.finish_date }}</td>
          <td>{{ item.turn_autopayment ? 'Да' : 'Нет' }}</td>
          <td><span :class="statusColor(item.status)">{{ item.status_name }}</span></td>
          <td>
            <v-btn @click="$router.push({name: 'credit-item', params: {id: item.id}})" class="action-btn"
                   color="success">
              <v-icon small>fas fa-eye</v-icon>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-pagination
        :length="options.last_page"
        v-if="options.last_page > 1"
        v-model="options.page"
    ></v-pagination>
  </div>
</template>

<script>
import CreditTableFilter from "@/components/credit/tableFilter";
import {debounce} from "@/utils/pureFunctions";

export default {
  data() {
    return {
      mkos: [],
      headers: [
        {text: '№', value: 'number', sortable: false},
        {text: 'Кредит №', value: 'credit_number', sortable: false},
        {text: 'Ф.И.О', value: 'full_name', sortable: false},
        {text: 'Сумма', value: 'amount', sortable: false},
        {text: 'Срок (мес.)', value: 'period', sortable: false},
        {text: 'Задолженность', value: 'current_debt', sortable: false},
        {text: 'Дата создания', value: 'created_at', sortable: false},
        {text: 'Дата', value: 'date', sortable: false},
        {text: 'Автосписание', value: 'turn_autopayment', sortable: false},
        {text: 'Статус', value: 'status', sortable: false},
        {text: 'Действие', value: 'action', sortable: false}
      ],
      items: [],
      options: {
        last_page: 1,
        current_page: 1
      },
      statusStep: 0,
      filters: {},
      current: 1
    }
  },
  components: {
    CreditTableFilter
  },
  methods: {
    async getItemsByFilter(filter) {
      this.filters = filter;
      this.options.page = 1;
      this.$showLoading()
      await this.getItems(filter)
      this.$clearLoading()
    },
    async statusSteps(status) {

    },
    async getItems(filter) {
      let params = {
        page: this.options.current_page,
        ...this.options
      }
      if (filter) {
        params = {...params, ...filter,}
      }
      try {
        const {data: {data, links: {last_page, current_page}}} = await this.$http.get('admin/credits', {
          params
        })
        this.items = data
        this.options.last_page = last_page
        this.current = current_page;
      } catch (e) {
        this.$setResponseError({error: e})
      }
    },
    statusColor(status) {
      switch (status) {
        case 0:
          return 'red--text';
        case 2:
          return 'green--text';
        case 3:
          return 'orange--text';
        case 5:
          return 'orange--text'
      }
    },
    getNumber(i) {
      return (this.current - 1) * 30 + i + 1;
    },
    getItemsWithLoading: debounce(async function () {
      this.$showLoading()
      await this.getItems(this.filters)
      this.$clearLoading()
    }, 50)
  },
  async created() {
    try {
      this.$showLoading()
      await this.getItems()
      this.mkos = await this.$store.dispatch('getMkos')
    } catch (e) {
      this.$setResponseError({error: e})
    } finally {
      this.$clearLoading()
    }
  },
  watch: {
    async "options.page"() {
      this.$showLoading()
      await this.getItems(this.filters)
      this.$clearLoading()
    },
    "statusStep": async function (val) {
      const status = val.substr(4);
      this.filters.status = status === 'all' ? null : status;
      this.options.page = 1;
      this.$showLoading()
      await this.getItems(this.filters)
      this.$clearLoading()

    }
  }
}
</script>
